import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Analytics, CookieConsent, ConsentValue } from '@utils'

/**
 * 페이지뷰 추적과 동의 변화 반영.
 * 전송 규칙(동의 확인·초기화 시점·쿼리 제거·제외 경로)은 `utils/Analytics` 에 있다.
 * 동의 전에는 GA 스크립트 자체를 올리지 않는다.
 */
const RouteChangeTracker = () => {
	const location = useLocation()
	const [consent, setConsent] = useState<ConsentValue | null>(() => CookieConsent.get())

	// 배너에서 동의/거부를 누르면 즉시 반영된다
	useEffect(() => CookieConsent.subscribe(setConsent), [])

	useEffect(() => {
		if (consent === 'granted') return

		// 이미 올라온 gtag 가 향상된 측정(스크롤·외부 링크)을 계속 보내지 않게 멈춘다.
		// 거부를 눌렀으면 _ga 쿠키도 지운다. 푸터 Cookie Settings 로 다시 묻는 중(null)에는 남긴다.
		Analytics.disable(consent === 'denied')
	}, [consent])

	// 공개 화면에서 올라온 GTM(광고 업체 태그)이 백오피스에서 돌지 않게 한다
	useEffect(
		() => Analytics.unloadGtmOnExcludedPath(location.pathname),
		[location.pathname],
	)

	useEffect(() => {
		if (consent !== 'granted') return

		// 경로가 바뀔 때만 — 해시(Works with 의 장비 모달)는 같은 페이지라 중복 pageview 가 된다.
		Analytics.pageview(location.pathname)
	}, [consent, location.pathname])
}

export default RouteChangeTracker
